<template>
  <el-dialog
    title="Owner数据编辑窗口"
    :visible.sync="visible"
    @close="close">

    <el-form :model="OwnerEditForm" label-position="right">
      <el-form-item label="Owner ID">
          <el-input v-model="OwnerEditForm.owner_id" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item label="类别">
          <el-input v-model="OwnerEditForm.type" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="OwnerEditForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮件地址">
          <el-input v-model="OwnerEditForm.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="OwnerEditForm.user_id" autocomplete="off"></el-input>
        </el-form-item>    
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      OwnerEditForm: {
        owner_id: '',
        type: '',
        name: '',
        email:'',
        user_id:'',
      },
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.OwnerEditForm.owner_id = data.owner_id;
      this.OwnerEditForm.type = data.type;
      this.OwnerEditForm.name = data.name;
      this.OwnerEditForm.email = data.email;
      this.OwnerEditForm.user_id = data.user_id;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.OwnerEditForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
